module.exports = __webpack_public_path__ + "static/img/empty2.6a71d290.png";